import React from 'react';
import { styledText, Wrapper } from './styled';
import { Icon, Text } from '@spaceshipapp/cambridge';

interface NotificationProps {
  variant?: 'default' | 'warning';
  message: React.ReactNode;
}

const Notification: React.FC<NotificationProps> = ({
  variant = 'default',
  message,
}): React.ReactElement => (
  <Wrapper variant={variant}>
    {variant === 'warning' && <Icon.Warning width={24} height={24} />}
    <Text className={styledText}>{message}</Text>
  </Wrapper>
);

export default Notification;
